<style lang="scss" scoped>

.list-inline-item {
    color: #FFFFFF;
}

.list-inline > li {
    line-height: 1.0rem;
    margin-top: 0.3rem;
    margin-bottom: 0.3rem;
    padding-top: 0rem;
    padding-bottom: 0.1rem;
    padding-left: 0.4rem;
    padding-right: 0.4rem;
    display: inline-block;
    list-style: none;
    font-size: 0.75rem;
   
    &:not(:first-child) {
        border-left: 2px #FFFFFF solid;
    }

    a {
        color: #FFFFFF;
        text-decoration: none;
        background-color: transparent;
    }
}

.footer-copyright {
    span {
        font-size: 0.75rem;
        color: #FFFFFF;
    }
}

.padding-footer {
    padding-bottom: 8rem;
} 

@media screen and (max-width: 768px) and (max-height: 720px) {
	.fixed-bottom {
		bottom: auto !important;
		position: static;
	}

    .padding-footer {
        padding-bottom: 1rem;
	}
}

</style>

<template>
    <div class="padding-footer">
    </div>
    <footer class="footer footer-transparent d-print-none p-0 mt-3 fixed-bottom"> 
        <div class="container-xs">
            <div class="row text-center align-items-center flex-row-reverse gx-0 px-3 pt-2 pb-2" style="background-color: #525252;">
                <div class="col-12">
                    <ul class="list-inline list-inline-dots  mb-0">
                        <li><a href="https://www.alb-bayern.de/M/bauen-bewaessern-biogas_Impressum.html" target="_blank">Impressum</a></li>
                        <li><a href="https://www.alb-bayern.de/M/bauen-bewaessern-biogas_AGB.html" target="_blank">AGB</a></li>
                        <li><a href="https://www.alb-bayern.de/M/bauen-bewaessern-biogas_Datenschutzerklaerung.html" target="_blank">Datenschutzerklärung</a></li>
                        <li><a href="https://www.alb-bayern.de/M/bauen-bewaessern-biogas_Haftungsausschluss.html" target="_blank">Haftungsausschluss</a></li>
                        <li><a href="https://www.alb-bayern.de/M/UeberUns/anmeldung-versand_Newsletter" target="_blank">Newsletter</a></li>
                        <li><a href="https://www.alb-bayern.de/M/geschaeftsstelle-alb_Kontakt.html" target="_blank">Kontakt</a></li>
                    </ul>
                </div>
            </div>
            <div class="row text-center align-items-center gx-0 py-2 px-3 footer-copyright bg-green-alb">
                <div class="col-12">
                    <span>
                         © {{ currentYear }} Arbeitsgemeinschaft Landtechnik und Landwirtschaftliches Bauwesen in Bayern e.V. 
                    </span>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>

import * as dayjs from 'dayjs';

export default {
    name: 'Footer',
    computed: {
        currentYear: function () {
            return dayjs().year();
        }
    }
}
</script>
